import { useState } from "react";
import { submitSupportCase } from "../../utils/supportNavUtils";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import ModalWrapper from "../../../../shared/components/ModalWrapper";

const CancellationDisclaimer = () => {
  const STATE = useAppStateStore();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState("");

  const handleCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
    if (e.target.checked) {
      setError("");
    }
  };

  const onClose = () => {
    STATE.setIsCancellationModalOpen(false);
  };

  const onClick = () => {
    if (!termsAccepted) {
      setError("You cannot proceed without acknowleding the disclaimer.");
      return;
    }
    submitSupportCase();
    onClose();
  };

  return (
    <ModalWrapper
      heading="Cancellation Disclaimer"
      simpleText="
            Our agent will provide a cancellation quote with instruction how to
            proceed with the cancellation. Please note that cancellations will
            only be processed during business hours which are Monday to Friday
            9am to 4pm. If a cancellation is requested outside of business hours
            to take effect immediately it will only be processed during business
            hours and cancellations will not be back dated.
        "
      buttonText="Proceed"
      showClose={true}
      onClose={onClose}
      onButtonClick={onClick}
      showCheckbox={true}
      checkboxLabel={"I have read and understood the disclaimer."}
      checkboxChecked={termsAccepted}
      checkboxError={error}
      onCheckboxChange={handleCheckboxChange}
    />
  );
};

export default CancellationDisclaimer;
